<template>
    <div
        class="container-fluid w-100 h-100"
        style="overflow-x: hidden"
    >
        <navbar
            v-if="showTitle"
            :title="$t('menu.cost_center')"
            class="mb-1"
            :show-back="false"
        />
    <cost-center-list :results="results" @add="addCostCenter" @edit="editCostCenter"/>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
    <base-modal
      v-if="editMode"
      size="lg"
      hide-header
      hide-footer
      @close="showList"
    >
      <cost-center-editor
        :cost-center="costCenter"
        @close="showList"
        @close-and-update="closeAndUpdate"
      />
    </base-modal>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import CostCenterList from './CostCenterList'
import CostCenterEditor from './CostCenterEditor'
import BaseModal from "@/components/BaseModal.vue";
import Navbar from "../utils/Navbar.vue";

export default {
    name: 'CostCenters',
    components: {Navbar, BaseModal, CostCenterList, CostCenterEditor},
    mixins: [restApi, workManagementHelper],
    props: {
        showTitle: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            results: [],
            costCenter: null,
            editMode: false,
            loading: false,
        }
    },
    mounted: function () {
        this.fetchCostCenters()
    },
    methods: {
        fetchCostCenters: function (companyId) {
            this.loading = true
            this.searchCompanyId = companyId
            this.results = []
            this.restFetchParams(this.costCenterUrl, {company: this.searchCompanyId}, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        addCostCenter: function () {
            this.costCenter = this.newCostCenter()
            this.editMode = true
        },
        editCostCenter: function (costCenter) {
            this.costCenter = costCenter
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchCostCenters(this.searchCompanyId)
            this.showList()
        }
    }
}
</script>
